// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

let Utils = {};

let node = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeDevelopments"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationSettings_userNotificationSettings",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsForSaleProperties_notificationSetting"
    },
    {
      "condition": "includeDevelopments",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NotificationSettingsNewDevelopments_notificationSetting"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsRentalProperties_notificationSetting"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsBuyerNeeds_notificationSetting"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsRentalNeeds_notificationSetting"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsBroadcastMessages_notificationSetting"
    }
  ],
  "type": "UserNotificationSettingsV5",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
